export const MAX_LOGIN_ATTEMPTS = 2;
